import { cases } from '@/mocks/services';

export default function CaseSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
            精选案例
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            用结果说话的品牌营销实践
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            每一个案例背后，都是我们对品牌需求的深度理解和对创意品质的极致追求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {item.description}
                </p>
                <div className="flex items-center gap-2 flex-wrap mb-4">
                  {item.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-1 bg-secondary-100 text-secondary-700 rounded-md text-xs font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="pt-4 border-t border-background-200/70 flex items-center justify-between">
                  <span className="text-sm text-foreground-500">核心成果</span>
                  <span className="text-sm font-semibold text-primary-600 font-heading">{item.result}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}